function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import ReactDOM from 'react-dom';
import Loader from 'react-loader-advanced';
import { WDHComponent } from '../../../../../../../wdh-foundation/wdh';
import TranslationManager from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/translation-manager';
import { EventTypes, TranslationKeys } from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/const';
import SelectList from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/components/select-list';
import Logger from '../../../../../../../wdh-foundation/wdh-logger/wdh-logger';
import UserManagementAddNewUserForm from './wdh-user-management-add-user-form';
import CheckUtils from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/utilities/check-utils';
import UserManagementAddNewUserPermissionTable from './wdh-user-management-add-user-permission-table';
import ApiClient from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/api/api-client';
import ModalDialog from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/components/modal-dialog';
import BrowseCategoriesUtils from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/utilities/browse-categories-utils';
import { loaderBackgroundStyle, loaderOpacity, spinner } from './views/Spinner';
import NavigationManager from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/navigation-manager';
var EventBus = window.DGS.Event.getInstance();
var WdhUserManagementAddUser = /*#__PURE__*/function (_WDHComponent) {
  /**
   * @constructor
   * @augments WDHComponent
   * @param className
   * @inheritDoc
   */
  function WdhUserManagementAddUser() {
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'wdh-feature-b2b-show-user-management-spot';
    _classCallCheck(this, WdhUserManagementAddUser);
    return _callSuper(this, WdhUserManagementAddUser, [className]);
  }
  _inherits(WdhUserManagementAddUser, _WDHComponent);
  return _createClass(WdhUserManagementAddUser, [{
    key: "init",
    value: function init(component) {
      var _this = this;
      ReactDOM.render(spinner, component.querySelector('.component-content'));
      window.shopInitReady === true ? this.checkAccess(component) : EventBus.on(EventTypes.SHOP_INIT_READY, function () {
        return _this.checkAccess(component);
      });
    }
  }, {
    key: "checkAccess",
    value: function checkAccess(component) {
      ReactDOM.render(/*#__PURE__*/React.createElement(AddNewUser, {
        className: this.className
      }), component.querySelector('.component-content'));
    }
  }]);
}(WDHComponent);
export default WdhUserManagementAddUser;
var AddNewUser = /*#__PURE__*/function (_React$Component) {
  function AddNewUser(props) {
    var _this2;
    _classCallCheck(this, AddNewUser);
    _this2 = _callSuper(this, AddNewUser, [props]);
    _this2.state = {
      showSaveUserModal: false,
      formNotComplete: false,
      userIdNotValid: false,
      emailNotValid: false,
      phoneNoNotValid: false,
      accountNotSelected: false,
      roleNotSelected: false,
      defaultNotSelected: false,
      showSaveUserModalError: false,
      toggleAccessAccounts: false,
      saveLoading: false,
      user: {
        fullName: '',
        firstName: '',
        middleName: '',
        lastName: '',
        userId: '',
        businessEmail: '',
        phone: '',
        fax: ''
      },
      newUser: {
        loginId: '',
        name: '',
        phoneNo: '',
        email: '',
        newUserAccounts: []
      },
      accountList: [],
      selectedAccounts: []
    };
    _this2.translations = {
      ViewPricingInformation: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_VIEW_PRICING_TEXT),
      AddUserAccountAccessText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ACCOUNT_ACCESS_TEXT),
      AddUserAddUserText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_ADD_USER_TEXT),
      AddUserFormText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_FORM_TEXT),
      AddUserAccountDescText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_ACCOUNT_DESC_TEXT),
      AddUserAccessText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_ACCESS_TEXT),
      AddUserRoleText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_ROLE_TEXT),
      AddUserDefaultAccountText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_DEFAULT_ACCOUNT_TEXT),
      AddUserNoAccountText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_NO_ACCOUNT_FOUND_TEXT),
      AddUserSaveButtonText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_SAVE_BUTTON_TEXT),
      AddUserModalOkText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_SAVE_MODAL_OK_TEXT),
      AddUserModalCancelText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_SAVE_MODAL_CANCEL_TEXT),
      AddUserModalConfirmationText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_SAVE_MODAL_CONFIRMATION_TEXT),
      AddUserDefaultNotSelectedText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_DEFAULT_NOT_SELECTED_TEXT),
      AddUserRoleNotSelectedText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_ROLE_NOT_SELECTED_TEXT),
      AddUserAccountNotSelectedText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_ACCOUNT_NOT_SELECTED_TEXT),
      AddUserFormNotCompleteText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_FORM_NOT_COMPLETE_TEXT),
      AddUserSaveModalErrorText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_SAVE_MODAL_ERROR_TEXT),
      AddUserSaveModalErrorOKText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_SAVE_MODAL_ERROR_OK_TEXT),
      AddUserUserIdNotValidText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_USER_ID_NOT_VALID_TEXT),
      AddUseremailNotValidText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_EMAIL_NOT_VALID_TEXT),
      AddUserPhoneNoNotValidText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_PHONE_NO_NOT_VALID_TEXT)
    };
    _this2.myDivToFocus = /*#__PURE__*/React.createRef();
    _this2.handleSortAccounts = _this2.handleSortAccounts.bind(_this2);
    return _this2;
  }
  _inherits(AddNewUser, _React$Component);
  return _createClass(AddNewUser, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this3 = this;
      ApiClient.userManagement.getAccountData().then(function (accountList) {
        _this3.setState({
          accountList: accountList
        });
      });
    }
  }, {
    key: "setData",
    value: function setData() {
      var newUser = {};
      var user = this.state.user;
      var userAcct = this.state.selectedAccounts.map(function (acct) {
        return {
          customerNumber: acct.customerNumber,
          isDefault: acct.isDefault,
          selectedRole: acct.selectedRole
        };
      });
      newUser.loginId = user.userId;
      newUser.name = user.fullName;
      newUser.phoneNo = user.phone;
      newUser.email = user.businessEmail;
      newUser.newUserAccounts = userAcct;
      return Promise.resolve(this.setState({
        newUser: newUser
      }));
    }
  }, {
    key: "handleUpdateUser",
    value: function handleUpdateUser(firstName, middleName, lastName, userId, businessEmail, phone, fax) {
      Logger.info(firstName + middleName + lastName + userId + businessEmail + phone + fax);
      var user = {};
      user.fullName = "".concat(firstName, " ").concat(middleName, " ").concat(lastName);
      user.firstName = firstName;
      user.middleName = middleName;
      user.lastName = lastName;
      user.userId = userId;
      user.businessEmail = businessEmail;
      user.phone = phone;
      user.fax = fax;
      this.setState({
        user: user
      });
      this.setState({
        formNotComplete: false,
        userIdNotValid: false,
        emailNotValid: false,
        phoneNoNotValid: false
      });
    }
  }, {
    key: "validation",
    value: function validation() {
      var validation = {};
      var valid = true;
      var field = [];
      if (!CheckUtils.isNullOrEmptyObject(this.state.user)) {
        var user = this.state.user;
        if (!CheckUtils.isNullOrEmptyString(user.firstName) || !CheckUtils.isNullOrEmptyString(user.lastName) || !CheckUtils.isNullOrEmptyString(user.userId) || !CheckUtils.isNullOrEmptyString(user.phone)) {
          // if  user has entered some  data check to make sure all fields are filled.
          if (CheckUtils.isNullOrEmptyString(user.firstName)) {
            valid = false;
            field.push('firstName');
          }
          if (CheckUtils.isNullOrEmptyString(user.lastName)) {
            valid = false;
            field.push('lastName');
          }
          if (CheckUtils.isNullOrEmptyString(user.userId)) {
            valid = false;
            field.push('userId');
          }
          if (CheckUtils.isNullOrEmptyString(user.phone)) {
            valid = false;
            field.push('phone');
          }
          if (CheckUtils.isNullOrEmptyString(user.businessEmail)) {
            valid = false;
            field.push('businessEmail');
          }
        }
      }
      validation.user = {
        field: field,
        valid: valid
      };
      var allValid = true;
      Object.entries(validation).forEach(function (entry) {
        if (!entry[1].valid) {
          allValid = false;
        }
      });
      validation.valid = allValid;
      return validation;
    }
  }, {
    key: "selectRole",
    value: function selectRole(event, account) {
      Logger.info(event.target);
      var selectRole = event.target.getAttribute('value');
      Logger.info("new role ".concat(selectRole));
      this.setState(function (prevState) {
        return {
          accountList: prevState.accountList.map(function (el) {
            return el === account ? _objectSpread(_objectSpread({}, el), {}, {
              selectedRole: selectRole
            }) : el;
          })
        };
      });
      var found = this.state.selectedAccounts.some(function (acct) {
        return acct.customerNumber === account.customerNumber;
      });
      if (this.state.selectedAccounts.length > 0 && found) {
        this.setState(function (prevState) {
          return {
            selectedAccounts: prevState.selectedAccounts.map(function (el) {
              return el.customerNumber === account.customerNumber ? _objectSpread(_objectSpread({}, el), {}, {
                selectedRole: selectRole
              }) : el;
            })
          };
        });
      }
      this.setState({
        roleNotSelected: false
      });
    }
  }, {
    key: "onChecked",
    value: function onChecked(accounts) {
      var found = this.state.selectedAccounts.some(function (acct) {
        return acct.customerNumber === accounts.customerNumber;
      });
      if (found) {
        var newSelectedAccounts = _toConsumableArray(this.state.selectedAccounts);
        var index = newSelectedAccounts.map(function (e) {
          return e.customerNumber;
        }).indexOf(accounts.customerNumber);
        if (index !== -1) {
          newSelectedAccounts.splice(index, 1);
          this.setState({
            selectedAccounts: newSelectedAccounts
          });
        }
      } else {
        this.setState({
          selectedAccounts: [].concat(_toConsumableArray(this.state.selectedAccounts), [accounts])
        });
      }
      this.setState({
        accountNotSelected: false,
        roleNotSelected: false,
        defaultNotSelected: false
      });
    }
  }, {
    key: "onDefaultSelected",
    value: function onDefaultSelected(accounts) {
      // make all true defaults false
      this.setState(function (prevState) {
        return {
          accountList: prevState.accountList.map(function (el) {
            return el.isDefault = _objectSpread(_objectSpread({}, el), {}, {
              isDefault: false
            });
          })
        };
      });
      // make the selected acct default true
      this.setState(function (prevState) {
        return {
          accountList: prevState.accountList.map(function (el) {
            return el.customerNumber === accounts.customerNumber ? _objectSpread(_objectSpread({}, el), {}, {
              isDefault: true
            }) : el;
          })
        };
      });

      // if acct is selected, update that too

      if (this.state.selectedAccounts.length > 0) {
        this.setState(function (prevState) {
          return {
            selectedAccounts: prevState.selectedAccounts.map(function (el) {
              return el.isDefault = _objectSpread(_objectSpread({}, el), {}, {
                isDefault: false
              });
            })
          };
        });
        this.setState(function (prevState) {
          return {
            selectedAccounts: prevState.selectedAccounts.map(function (el) {
              return el.customerNumber === accounts.customerNumber ? _objectSpread(_objectSpread({}, el), {}, {
                isDefault: true
              }) : el;
            })
          };
        });
      }
      this.setState({
        defaultNotSelected: false
      });
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      if (this.myDivToFocus.current) {
        this.myDivToFocus.current.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
    }
  }, {
    key: "isValidEmailAddress",
    value: function isValidEmailAddress(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }, {
    key: "saveNewUser",
    value: function saveNewUser(e) {
      var _this4 = this;
      e.preventDefault();
      this.setData().then(function (x) {
        var user = _this4.state.newUser;
        var userDemo = _this4.state.user;
        var defaultCheck = user.newUserAccounts.map(function (acct) {
          return acct.isDefault;
        });
        var roleChecker = user.newUserAccounts.map(function (acct) {
          return CheckUtils.isNullOrEmptyString(acct.selectedRole);
        });
        var defaultChecker = function defaultChecker(arr) {
          return arr.find(function (v) {
            return v === true;
          });
        };
        var checker = function checker(arr) {
          return arr.every(function (v) {
            return v === false;
          });
        };
        if (CheckUtils.isNullOrEmptyString(userDemo.firstName) || CheckUtils.isNullOrEmptyString(userDemo.lastName) || CheckUtils.isNullOrEmptyString(user.email) || CheckUtils.isNullOrEmptyString(user.loginId) || CheckUtils.isNullOrEmptyString(user.phoneNo)) {
          _this4.setState({
            formNotComplete: true
          });
          _this4.handleScroll();
        } else if (!_this4.isValidEmailAddress(user.loginId)) {
          _this4.setState({
            userIdNotValid: true
          });
        } else if (!_this4.isValidEmailAddress(user.email)) {
          _this4.setState({
            emailNotValid: true
          });
        } else if (user.phoneNo.replace(/[^\d]/g, '').length < 10) {
          _this4.setState({
            phoneNoNotValid: true
          });
        } else if (CheckUtils.isNullOrEmptyArray(user.newUserAccounts)) {
          _this4.setState({
            accountNotSelected: true
          });
        } else if (!checker(roleChecker)) {
          _this4.setState({
            roleNotSelected: true
          });
        } else if (!defaultChecker(defaultCheck)) {
          _this4.setState({
            defaultNotSelected: true
          });
        } else {
          _this4.setState({
            saveLoading: true
          });
          ApiClient.userManagement.addNewUser(_this4.state.newUser).then(function (users) {
            _this4.setState({
              saveLoading: false
            });
            _this4.setState({
              showSaveUserModal: true
            });
          }, function (error) {
            _this4.setState({
              saveLoading: false
            });
            _this4.setState({
              showSaveUserModalError: true
            });
            Logger.error('--- ERROR ---');
            Logger.error(error);
          });
        }
      });
    }
  }, {
    key: "navigateUserMng",
    value: function navigateUserMng(event) {
      event.preventDefault();
      var url = '/myoticon/myaccount/edit-profile/user-management';
      NavigationManager.navigate(url);
    }
  }, {
    key: "reloadAddUserPage",
    value: function reloadAddUserPage(event) {
      event.preventDefault();
      window.location.reload();
    }
  }, {
    key: "handleSortAccounts",
    value: function handleSortAccounts() {
      this.setState(function (prevState) {
        return {
          toggleAccessAccounts: !prevState.toggleAccessAccounts
        };
      });
      if (this.state.toggleAccessAccounts) {
        var accountList = _toConsumableArray(this.state.accountList).sort(function (a, b) {
          if (a.customerNumber < b.customerNumber) return -1;
          if (a.customerNumber > b.customerNumber) return 1;
          return 0;
        });
        this.setState({
          accountList: accountList
        });
      } else {
        var _accountList = _toConsumableArray(this.state.accountList).sort(function (a, b) {
          if (a.customerNumber > b.customerNumber) return -1;
          if (a.customerNumber < b.customerNumber) return 1;
          return 0;
        });
        this.setState({
          accountList: _accountList
        });
      }
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        showSaveUserModalError: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var validationResults = this.validation();
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, this.translations.AddUserAddUserText), /*#__PURE__*/React.createElement("p", {
        ref: this.myDivToFocus
      }, this.translations.AddUserFormText), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Loader, {
        show: this.state.saveLoading,
        message: spinner,
        contentBlur: loaderOpacity,
        backgroundStyle: loaderBackgroundStyle
      }, /*#__PURE__*/React.createElement(UserManagementAddNewUserForm, {
        user: this.state.user,
        onUserUpdated: function onUserUpdated(firstName, middleName, lastName, userId, businessEmail, phone, fax) {
          _this5.handleUpdateUser(firstName, middleName, lastName, userId, businessEmail, phone, fax);
        },
        errors: validationResults.user
      }), /*#__PURE__*/React.createElement("h3", null, this.translations.AddUserAccountAccessText), /*#__PURE__*/React.createElement("p", {
        className: "account-access-text"
      }, this.translations.AddUserAccountDescText), /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "data-list-spot__table-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "data-list-spot__table headers"
      }, /*#__PURE__*/React.createElement("div", {
        className: "data-list-spot__headers"
      }, /*#__PURE__*/React.createElement("div", {
        className: "data-list-spot__headers__header sortable ".concat(this.state.toggleAccessAccounts ? 'ordered_asc' : 'ordered_desc'),
        onClick: this.handleSortAccounts,
        onKeyPress: this.handleSortAccounts,
        role: "button",
        "data-title": "access",
        tabIndex: "0"
      }, /*#__PURE__*/React.createElement("span", null, this.translations.AddUserAccessText)), /*#__PURE__*/React.createElement("div", {
        className: "data-list-spot__headers__header",
        role: "button",
        "data-title": "role",
        tabIndex: "0"
      }, /*#__PURE__*/React.createElement("span", null, this.translations.AddUserRoleText)), /*#__PURE__*/React.createElement("div", {
        className: "data-list-spot__headers__header list-description",
        role: "button",
        "data-title": "defaultAccount",
        tabIndex: "0"
      }, /*#__PURE__*/React.createElement("span", null, this.translations.AddUserDefaultAccountText))), this.state.accountList.length > 0 && this.state.accountList.map(function (account) {
        var rolesList = BrowseCategoriesUtils.mapToSelectItemsUsers(account.roles);
        return /*#__PURE__*/React.createElement("div", {
          className: "data-list-spot__row data-list-spot__row__cell ".concat(1),
          key: account.customerNumber
        }, /*#__PURE__*/React.createElement("div", {
          className: "data-list-spot__row__column"
        }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          id: account.customerNumber,
          className: "select-account-checkbox",
          onChange: function onChange() {
            return _this5.onChecked(account);
          },
          checked: _this5.state.selectedAccounts.some(function (acct) {
            return acct.customerNumber === account.customerNumber;
          })
        }), /*#__PURE__*/React.createElement("label", {
          htmlFor: account.customerNumber
        })), /*#__PURE__*/React.createElement("span", null, account.customerNumber)), /*#__PURE__*/React.createElement("div", {
          className: "data-list-spot__row__column"
        }, /*#__PURE__*/React.createElement(SelectList, {
          label: "Choose role",
          id: "roleSelector",
          items: rolesList,
          addBlankItem: false,
          selectedValue: account.selectedRole,
          onValueChange: function onValueChange(event) {
            return _this5.selectRole(event, account);
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: "data-list-spot__row__column"
        }, /*#__PURE__*/React.createElement("input", {
          type: "radio",
          id: "default" + account.customerNumber,
          name: "user-account",
          onClick: function onClick() {
            return _this5.onDefaultSelected(account);
          },
          defaultChecked: account.isDefault
        }), /*#__PURE__*/React.createElement("label", {
          htmlFor: "default" + account.customerNumber
        })));
      })))), this.state.accountList.length <= 0 && /*#__PURE__*/React.createElement("div", {
        className: "no-accounts-found-text"
      }, "Account information could not be loaded at this time. Please reload the page or", ' ', /*#__PURE__*/React.createElement("a", {
        href: "mailto:helpwithmyoticon@oticon.com"
      }, "\xA0 contact us \xA0"), ' ', "for assistance.")), /*#__PURE__*/React.createElement(UserManagementAddNewUserPermissionTable, null), /*#__PURE__*/React.createElement("div", null, this.state.accountNotSelected && /*#__PURE__*/React.createElement("p", {
        className: "warning-msg account-missing"
      }, this.translations.AddUserAccountNotSelectedText), this.state.formNotComplete && /*#__PURE__*/React.createElement("p", {
        className: "warning-msg text-missing"
      }, this.translations.AddUserFormNotCompleteText), this.state.roleNotSelected && /*#__PURE__*/React.createElement("p", {
        className: "warning-msg"
      }, this.translations.AddUserRoleNotSelectedText), this.state.defaultNotSelected && /*#__PURE__*/React.createElement("p", {
        className: "warning-msg default-missing"
      }, this.translations.AddUserDefaultNotSelectedText), this.state.userIdNotValid && /*#__PURE__*/React.createElement("p", {
        className: "warning-msg"
      }, this.translations.AddUserUserIdNotValidText), this.state.emailNotValid && /*#__PURE__*/React.createElement("p", {
        className: "warning-msg text-missing"
      }, this.translations.AddUseremailNotValidText), this.state.phoneNoNotValid && /*#__PURE__*/React.createElement("p", {
        className: "warning-msg default-missing"
      }, this.translations.AddUserPhoneNoNotValidText), /*#__PURE__*/React.createElement("button", {
        className: "wdh-feature-b2b-button dark-bg add-user-save-btn",
        disabled: this.state.formNotComplete || this.state.accountNotSelected || this.state.roleNotSelected || this.state.defaultNotSelected || this.state.phoneNoNotValid || this.state.emailNotValid || this.state.userIdNotValid,
        onClick: function onClick(e) {
          _this5.saveNewUser(e);
        }
      }, this.translations.AddUserSaveButtonText)))), /*#__PURE__*/React.createElement(ModalDialog, {
        isOpen: this.state.showSaveUserModal,
        className: "wdh-feature-btb-modalContent wdh-feature-btb-modalContent-userMng-AddUser-Modal",
        type: ModalDialog.types.okCancel,
        okLabel: this.translations.AddUserModalOkText,
        onOkClick: function onOkClick(event) {
          return _this5.navigateUserMng(event);
        },
        onCancelClick: function onCancelClick(event) {
          return _this5.reloadAddUserPage(event);
        },
        cancelLabel: this.translations.AddUserModalCancelText
      }, /*#__PURE__*/React.createElement("p", null, this.translations.AddUserModalConfirmationText)), /*#__PURE__*/React.createElement(ModalDialog, {
        isOpen: this.state.showSaveUserModalError,
        type: ModalDialog.types.okCancel,
        okLabel: "Try again",
        onOkClick: function onOkClick(event) {
          _this5.saveNewUser(event);
          _this5.closeModal(event);
        },
        onCancelClick: function onCancelClick(event) {
          return _this5.closeModal(event);
        },
        cancelLabel: "Cancel"
      }, /*#__PURE__*/React.createElement("p", null, "We\u2019re sorry, an error has occurred. Please try again. If the issue continues, please contact us at ", /*#__PURE__*/React.createElement("a", {
        href: "mailto: helpwithmyoticon@oticon.com"
      }, "helpwithmyoticon@oticon.com"))));
    }
  }]);
}(React.Component);